/**
 * Carte affichant un template d'email
 */

import { EmailTemplate } from "@/types/emailTemplates";

interface TemplateCardProps {
  template: EmailTemplate;
  onEdit: (template: EmailTemplate) => void;
  onDelete: (id: string) => void;
}

export function TemplateCard({ template, onEdit, onDelete }: TemplateCardProps) {
  const handleDelete = () => {
    if (window.confirm(`Supprimer le template "${template.name}" ?\n\nCette action est irréversible.`)) {
      onDelete(template.id);
    }
  };

  // Truncate body pour affichage
  const truncatedBody = template.body.length > 150 
    ? template.body.substring(0, 150) + "..." 
    : template.body;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
      {/* Header avec couleur et nom */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div
            className="w-4 h-4 rounded-full flex-shrink-0"
            style={{ backgroundColor: template.color }}
            title="Couleur du bouton"
          />
          <h3 className="font-semibold text-gray-900 truncate">
            {template.name}
          </h3>
        </div>
        
        {/* Actions */}
        <div className="flex items-center gap-1 ml-2">
          <button
            onClick={() => onEdit(template)}
            className="p-1.5 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded transition-colors"
            title="Modifier"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </button>
          <button
            onClick={handleDelete}
            className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
            title="Supprimer"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      </div>

      {/* Corps du message (preview) */}
      <div className="mb-3">
        <p className="text-sm text-gray-600 whitespace-pre-wrap break-words">
          {truncatedBody}
        </p>
      </div>

      {/* Footer avec date */}
      <div className="text-xs text-gray-400">
        Créé le {new Date(template.created_at).toLocaleDateString("fr-FR")}
      </div>
    </div>
  );
}

